<template>
    <div class="review">
        <div class="review__avatar" :style="{'background-image': `url(${avatar})`}"></div>

        <div v-if="user == this.$store.getters.profile.id" class="review__content">
            <h4>{{name}}</h4>

            <div class="review__rating">
                <rating-stars :rating="rating" hideRating />
            </div>

            <div class="review__entry">
                <p>{{text}}</p>
            </div>

            <base-button variant="primary" :to="`/book/${routeId}/comment/update`" >
                <icon-undo />
                <span>Modifica recensione</span>
            </base-button>

        </div>
        <div v-else class="review__content">
            <h4>{{name}}</h4>

            <div class="review__rating">
                <rating-stars :rating="rating" hideRating />
            </div>

            <div class="review__entry">
                <p>{{text}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import RatingStars from '@/components/rating-stars/rating-stars';
import { useRoute } from 'vue-router';
import BaseButton from '@/components/base-button/base-button';
import IconUndo from '@/components/icons/icon-undo/icon-undo';


export default {
    name: 'Review',

    components: {
        RatingStars,
        BaseButton,
        IconUndo
    },

    props: {
        user: {
            type: Number,
            default: 0
        },
        name: {
            type: String,
            default: ''
        },
        avatar: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
        rating: {
            type: [String, Number],
            default: ''
        }
    },

    setup() {
        const route = useRoute();

        return {
            routeId: computed(() => route.params.id),
        }

    }
}
</script>
